<template>
  <div class="table-search">
    <div
      class="table-search-item"
      v-for="searchItem in searchList"
      :key="searchItem.prop"
    >
      <component
        :is="'search-' + searchItem.type"
        :items="searchItem.items"
        v-model="searchForm[searchItem.prop]"
        @search="search"
        :attrs="searchItem.attrs"
      />
    </div>
    <div class="table-search-item">
      <el-button @click="search" style="height: 100%" type="primary">
        查询
      </el-button>
    </div>
    <div class="table-search-item">
      <el-button @click="clear" style="height: 100%">清空</el-button>
    </div>
  </div>
</template>

<script>
import SearchSelect from "@/components/prod/center/components/SearchSelect.vue";
import SearchInput from "@/components/prod/center/components/SearchInput.vue";
import SearchDate from "@/components/prod/center/components/searchDate.vue";
import { PLATFORM_OPTIONS } from "@/dictionary/platforms.js"
import { cloneDeep } from "lodash";

export default {
  components: {
    SearchSelect,
    SearchInput,
    SearchDate,
  },
  props: {
    total: Number,
  },
  data() {
    return {
      searchForm: {
        supplierCompanyId: "",
        outerIds: "",
        skuOuterIds: "",
        title: "",
        updateTime: [],
      },
      PLATFORM_OPTIONS,
      searchList: [
        {
          prop: "source", 
          type: 'select', 
          attrs:{
            placeholder: '已完善资料的平台',
            style: 'width: 200px;',
          }, 
          items: PLATFORM_OPTIONS
        },
        {
          prop: "updateTime", 
          type: 'date',
          attrs: {
            startPlaceholder: "上架开始日期",
            endPlaceholder: "上架结束日期",
            rangeSeparator: '至',
            type: 'daterange',
            clearable: true,
          },
        },
        {
          prop: "outerIds",
          type: "input",
          attrs: {
            placeholder: "多个款式编码，以英文逗号分割",
            label: "款式编码",
            isDialog: true,
          },
        },
        {
          prop: "skuOuterIds",
          type: "input",
          attrs: {
            placeholder: "多个商品编码，以英文逗号分割",
            label: "商品编码",
            isDialog: true,
          },
        },
        {
          prop: "title",
          type: "input",
          attrs: {
            placeholder: "商品名称",
          },
        },
      ],
    };
  },
  computed: {
    query() {
      let _query = {};
      for (const key in this.searchForm) {
        if (this.searchForm[key] !== "") {
          _query[key] = this.searchForm[key];
        }
      }
      return _query;
    }
  },
  methods: {
    method_getSearchForm() {
      let result = cloneDeep(this.query);
      if (result.updateTime.length) {
        result.updateTimeBegin = result.updateTime[0];
        result.updateTimeEnd = result.updateTime[1];
      }
      delete result.updateTime;
      return result;
    },
    search() {
      this.$emit("search", this.query);
    },
    clear() {
      this.searchForm = {
        platform: "",
        outerIds: "",
        skuOuterIds: "",
        title: "",
        updateTime: [],
      };
      this.search();
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.table-search {
  display: flex;
  flex-wrap: wrap;

  &-item {
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
</style>
